export const levelFilterOptions = [
  { value: 1, label: "achievement-level-filter-first-option" },
  { value: 2, label: "achievement-level-filter-second-option" },
  { value: 3, label: "achievement-level-filter-third-option" },
];
